/**
 * AuditExamination.jsx — Subtab XI
 */

import React from "react";
import { AuditFacility } from "../diagrams.jsx";
import { SubtabHeading, GapBlock, SolutionLead, Body, P } from "../SubtabFrame.jsx";

export default function AuditExamination() {
  return (
    <article>
      <SubtabHeading roman="XI">Regulatory Examination and Client Audit Rights</SubtabHeading>
      <AuditFacility />
      <GapBlock>
        Law firms representing regulated clients face client-driven audit
        rights into firm systems. These audits must work in an air-gapped
        environment.
      </GapBlock>
      <SolutionLead>
        Audit rights are actually easier to satisfy in this architecture than
        in cloud-based AI, and CoConsoleX makes this an affirmative selling
        point.
      </SolutionLead>
      <Body>
        <P>
          The engagement letter grants the engaging firm and its clients
          (where the underlying client engagement requires it) the right to
          conduct on-site audits of CoConsoleX's air-gapped facility with
          reasonable notice. Because the facility is physically located and
          CoConsoleX is a law firm subject to professional discipline, audits
          work the same way they work for any law firm — the auditor visits,
          reviews access logs and procedures, interviews personnel, and
          produces a report.
        </P>
        <P>
          This is structurally easier than auditing a cloud AI vendor. A
          bank's OCC examiner cannot meaningfully audit OpenAI's data centers;
          the bank's law firm using OpenAI for AI-augmented work has no good
          answer to "show me the controls protecting our privileged
          information." The same examiner can audit CoConsoleX's facility
          directly.
        </P>
        <P>
          CoConsoleX maintains a standard audit package — SOC 2 Type II report
          with AI-specific controls, ISO 27001 certification, NIST 800-53
          control mapping at the High baseline, and CMMC Level 3 readiness
          for engagements involving CUI. These certifications are non-trivial
          to obtain (twelve to eighteen months and significant investment) but
          they're the price of admission for serving the regulated-client
          market.
        </P>
        <P>
          For defense-sector clients specifically, CoConsoleX pursues DoD
          facility clearance (FCL) at the Secret level so that
          classified-adjacent work (which is most of what defense industry
          firms do) can be performed in a credibly secured environment. This
          is also a competitive moat — facility clearance takes years to
          obtain and the cleared-facility population in private-sector legal
          services is small.
        </P>
      </Body>
    </article>
  );
}
